import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { KeyPads, Modal } from "components"
import SccsmFooter from "./SccsmFooter"
import SccsmHeader from "./SccsmHeader"
import classes from "./index.module.scss"

const ShiftCashierCloseShiftModal = props => {
  const {
    expectedCashAmount,
    showCloseShiftModal,
    setShowCloseShiftModal
  } = props

  const i18n = useTranslation()[1]

  const [printReport, setPrintReport] = useState(true)
  const [actualCashAmount, setActualCashAmount] = useState(0)

  const handleChange = (value) => {
    setActualCashAmount(value)
  }

  const handleEnter = () => {
    setActualCashAmount(expectedCashAmount)
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Modal
      show={showCloseShiftModal}
      onEnter={handleEnter}
    >
      <div className={classes["container"]}>
        <SccsmHeader
          printReport={printReport}
          setPrintReport={setPrintReport}
          actualCashAmount={actualCashAmount}
          expectedCashAmount={expectedCashAmount}
        />

        <div
          className={clsx(
            classes["key-pads"],
            isLtr && classes["key-pads-ltr"]
          )}
        >
          <KeyPads
            value={actualCashAmount}
            onChange={handleChange}
          />
        </div>

        <SccsmFooter
          printReport={printReport}
          expectedCashAmount={expectedCashAmount}
          actualCashAmount={actualCashAmount}
          setActualCashAmount={setActualCashAmount}
          setShowCloseShiftModal={setShowCloseShiftModal}
        />
      </div>
    </Modal>
  )
}

export default ShiftCashierCloseShiftModal